import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var DutiesInvoiceIA = function DutiesInvoiceIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize), YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_INVOICES_WITH_FAIRE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_INVOICES_WITH_FAIRE = function DUTIES_INVOICES_WITH_FAIRE(strictLocalize) {
  return strictLocalize({
    id: "GUFPUU",
    defaultMessage: [{
      "type": 0,
      "value": "Duties invoices with Faire"
    }]
  });
};
var ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE = function ORDERS_WITH_DUTIES_ELIGIBLE_GOODS_GENERATE_DUTIES_INVOICE(strictLocalize) {
  return strictLocalize({
    id: "nV464S",
    defaultMessage: [{
      "type": 0,
      "value": "All orders that have duties eligible goods generate a duties invoice. If duties are covered for your order, we’ll apply a discount to your invoice at checkout that reflects the estimated cost of import duties for your order. The carrier will send you an invoice for all import fees (including import duties and VAT) when the order ships, which you’ll pay in full. If the duties are covered and actual cost of import duties and disbursement fees is greater than the duties promotion you received, you can request a refund in Faire credit for the difference when the order is delivered."
    }]
  });
};
var YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES = function YOU_WILL_BE_RESPONSIBLE_FOR_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "XjOUVq",
    defaultMessage: [{
      "type": 0,
      "value": "If duties are not covered for your order, you will be responsible for duties fees."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "C5Am+H",
    defaultMessage: [{
      "type": 0,
      "value": "This order is eligible for free duties promotion. All orders that have duties eligible goods generate a duties invoice. Since duties are covered for your order, we’ll apply a discount to your invoice at checkout that reflects the estimated cost of import duties for your order. The carrier will send you an invoice for all import fees (including import duties and VAT) when the order ships, which you’ll pay in full. If the actual cost of import duties and disbursement fees is greater than the duties promotion you received, you can request a refund in Faire credit for the difference when the order is delivered."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "0Ut9wH",
    defaultMessage: [{
      "type": 0,
      "value": "This order is not eligible for free duties promotion. All orders that have duties eligible goods generate a duties invoice. Since duties are not covered for your order, you will be responsible for duties fees. The carrier will send you an invoice for all import fees (including import duties and VAT) when the order ships, which you’ll pay in full."
    }]
  });
};